var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collapsed-footered" }, [
    _c(
      "div",
      {
        staticClass: "collapsed-footer__head",
        on: { click: _vm.toggleCollapse }
      },
      [
        _c(
          "div",
          { staticClass: "collapsed-footer__head-title" },
          [_vm._t("head")],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapsed-footer__head-ico",
            class: { open: !_vm.isCollapsed, collapsed: _vm.isCollapsed }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  "enable-background": "new 0 0 14 9",
                  viewBox: "0 0 14 9",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "clip-rule": "evenodd",
                    d: "m.3 1.4 1.4-1.4 5.3 5.3 5.3-5.3 1.4 1.4-6.7 6.7z",
                    fill: "currentColor",
                    "fill-rule": "evenodd"
                  }
                })
              ]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "collapse",
        staticClass: "collapsed-footer__content",
        class: { open: !_vm.isCollapsed, collapsed: _vm.isCollapsed }
      },
      [_vm._t("content")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "collapsed-footer__footer" },
      [_vm._t("footer")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }